import { render, staticRenderFns } from "./NotifyMfa.vue?vue&type=template&id=49c89a1e&"
import script from "./NotifyMfa.vue?vue&type=script&lang=ts&"
export * from "./NotifyMfa.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports